module.exports = __webpack_public_path__ + "static/img/图标_google.d669e966.svg";